import { render } from "./PlaylistPage.vue?vue&type=template&id=0b6af61a&scoped=true"
import script from "./PlaylistPage.vue?vue&type=script&lang=js"
export * from "./PlaylistPage.vue?vue&type=script&lang=js"

import "./PlaylistPage.vue?vue&type=style&index=0&id=0b6af61a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6af61a"]])

export default __exports__